import { render, staticRenderFns } from "./SwitchServerModal.vue?vue&type=template&id=2afacff4&scoped=true&"
import script from "./SwitchServerModal.vue?vue&type=script&lang=ts&"
export * from "./SwitchServerModal.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchServerModal.vue?vue&type=style&index=0&id=2afacff4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afacff4",
  null
  
)

export default component.exports